import { atom } from 'jotai';

export const userListAtom = atom({
    records: [],
    total: 0,
    url: "",
    canFetch: false,
    done: false
})
